import { wrapLazyNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';
import 'react-native-gesture-handler';

const CommentPageContent = lazy(
  () => import('./components/CommentPageContent'),
);

export const CommentPage = wrapLazyNavigatorScreen(CommentPageContent, {
  headerShown: false,
});
